// extracted by mini-css-extract-plugin
export default {"timerHeader":"timerHeader--zBqYR","bubble":"bubble--NMFmx"};